<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<figure class="figure">
<p class="fig"><img alt="Great Lakes Books series logo" height="75" src="images/glb-logo.jpg" width="85"/></p>
</figure>
<p class="sert"><span aria-label=" Page ii. " class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span>Great Lakes Books</p>
<p class="serpf">A complete listing of the books in this series can be found online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a>.</p>
<p class="serah">Editor</p>
<p class="sered">Thomas Klug</p>
<p class="ser1">Sterling Heights, Michigan</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gallagher-0004.vue?33cefa8f